import { render, staticRenderFns } from "./KcList.vue?vue&type=template&id=39aa9cd8&scoped=true"
import script from "./KcList.vue?vue&type=script&lang=js"
export * from "./KcList.vue?vue&type=script&lang=js"
import style0 from "./KcList.vue?vue&type=style&index=0&id=39aa9cd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa9cd8",
  null
  
)

export default component.exports